import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class ONVIFTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "actionColumn", title: "Video Aufnahme" },
        { name: "descriptionColumn", title: "Beschreibung" }
      ],
      rows: [
        { actionColumn: 'Aufnahme auf SD Karte', descriptionColumn: 'Aktivieren, um die geplanten Video Aufnahme auf der internen SD Karte zu speichern. Bitte beachten Sie, dass die Aufnahme nur startet wenn der AUFNAHME ZEITPLAN aktiv ist.' },
        { actionColumn: 'Auflösung', descriptionColumn: 'Wählen Sie die die Videoauflösung für die geplante Aufnahme auf die SD Karte - 1440p, 1080p oder 360p. Beachten Sie, das mit der Auflösung auch der Video Codec gewählt wird (h.265, h.264)' },
        { actionColumn: 'Dateilänge', descriptionColumn: 'Stellen Sie die maximale Dateilänge für die geplante Video Aufnahme ein. Hiermit wird alle 15s - 900s eine neue Datei begonnen.' },
        { actionColumn: 'Alles auswählen', descriptionColumn: 'Klicken Sie hier um die Alarm Aktionen 24/7 zu aktivieren. Jede aktive Alarm Funktion, (Bewegungserkennung, Audio Alarm und externer Alarmeingang) kann die gesetzten Alarmaktionen auslösen.' },
        { actionColumn: 'Nichts auswählen', descriptionColumn: 'Klicken Sie hier um die 24/7 Alarm Aktionen zu deaktivieren. Jede aktive Alarm Funktion (Bewegungserkennung, Audio Alarm und externer Alarmeingang) kann die gesetzten Alarmaktionen auslösen.' },
        { actionColumn: 'Arbeitszeit', descriptionColumn: 'Klicken Sie hier, wenn Sie die Alarm Aktionen während der normalen Arbeitszeiten aktiviert haben möchten. Alle aktiven Alarm Funktionen werden nur während dieser Zeit Alarm Aktionen auslösen.' },
        { actionColumn: 'Nachtzeit', descriptionColumn: 'Klicken Sie hier, wenn Sie die Alarm Aktionen während der Nacht aktiviert haben möchten. Alle aktiven Alarm Funktionen werden nur während dieser Zeit Alarm Aktionen auslösen.' },
        { actionColumn: 'Benutzerdefiniert', descriptionColumn: 'Klicken Sie unten links auf Plan merken, um Ihren aktuellen Zeitplan zu speichern. Im Anschluß können Sie mit einem Klick auf Benutzerdefiniert diesen Plan jederzeit wieder herstellen.' },
        { actionColumn: 'Alles Umkehren', descriptionColumn: 'Dieser Button kehrt das ausgewählte Zeitfenster um.' },
        { actionColumn: 'Plan merken', descriptionColumn: 'Klicken Sie auf diese Schaltfläche, um einen von Ihnen erstellten Zeitplan zu speichern. Dieser Zeitplan kann dann durch Klicken auf den voreingestellten Zeitplan Benutzerdefiniert ausgewählt werden.' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

ONVIFTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(ONVIFTable)